var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup47218(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 263,
    viewBox: "0 0 263 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8945_306)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 131.5,
    r: 131.5,
    fill: "#BBAAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8945_306",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 263,
    height: 263
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 131.5,
    r: 131.5,
    fill: "#C3EEFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8945_306)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8945_306)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.379,
    cy: 66.783,
    rx: 154.676,
    ry: 127.973,
    fill: "#D7F8FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8945_306)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.936,
    cy: -10.2931,
    rx: 154.676,
    ry: 127.973,
    fill: "#FFFCED"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_8945_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.734 6.7662C40.8918 36.7729 21.4757 89.1376 21.4757 185.63C-31.9779 185.63 -68.8386 63.7942 -68.8386 6.7662C-68.8386 -50.2618 -25.5059 -96.4922 27.9477 -96.4922C81.4014 -96.4922 124.734 -50.2618 124.734 6.7662Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8945_306",
    x: -9.41387,
    y: -7.0604,
    width: 272.414,
    height: 270.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9.41387,
    dy: -7.0604
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.9441
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8945_306"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8945_306",
    x: -111.79,
    y: -157.682,
    width: 502.337,
    height: 448.931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 48.2461,
    result: "effect1_foregroundBlur_8945_306"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8945_306",
    x: 11.7675,
    y: -234.758,
    width: 502.337,
    height: 448.931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 48.2461,
    result: "effect1_foregroundBlur_8945_306"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8945_306",
    x: -113.555,
    y: -141.208,
    width: 283.005,
    height: 371.554,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.3579,
    result: "effect1_foregroundBlur_8945_306"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47218);
export default __webpack_public_path__ + "static/media/Group 47218.721c07850e18ddc7490092646a29619e.svg";
export { ForwardRef as ReactComponent };